"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let FileSelector = class FileSelector extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "modal",
    };
    beforeCreate() {
    }
    multiple;
    onMultiple(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("multiple");
    }
    url;
    onUrl(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("url");
    }
    payload;
    onPayload(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("payload");
    }
    accept;
    onAccept(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("accept");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    selectedFiles;
    ux;
    dataMembers = ['selectedFiles', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                selectedFiles: null,
                ux: null,
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("FileSelector|Header", "Select file(s)"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_2416_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async act_7786837829063213_closeModal_2420_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                value: $event.data.response.data,
            },
        };
    }
    async act_7786837829063213_request_2418_getActionArgs($event) {
        return {
            url: this.url,
            method: "POST",
            data: { ...this.payload, file: this.selectedFiles },
            contentType: "multipart/form-data",
        };
    }
    async evh_7786837829063213_click(event, scope) {
        return await this.actions.evh_7786837829063213_click.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_2416 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_2416_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_2415 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_2416,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_2415],
        });
        const act_7786837829063213_closeModal_2420 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7786837829063213_closeModal_2420_getActionArgs,
            events: [],
        });
        const evh_7786837829063213_success_2419 = new core_1.actions.EventHandlerImpl({
            action: act_7786837829063213_closeModal_2420,
            event: "success",
            displayName: "closeModal",
        });
        const act_7786837829063213_request_2418 = new core_1.actions.RequestAction({
            actionArgs: this.act_7786837829063213_request_2418_getActionArgs,
            displayName: "submit",
            events: [evh_7786837829063213_success_2419],
        });
        const evh_7786837829063213_click_2417 = new core_1.actions.EventHandlerImpl({
            action: act_7786837829063213_request_2418,
            event: "click",
            displayName: "submit",
        });
        const evh_7786837829063213_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7786837829063213_click_2417],
        });
        return {
            act_7315092382398562_closeModal_2416,
            evh_7315092382398562_close_2415,
            evh_7315092382398562_close,
            act_7786837829063213_closeModal_2420,
            evh_7786837829063213_success_2419,
            act_7786837829063213_request_2418,
            evh_7786837829063213_click_2417,
            evh_7786837829063213_click,
            submit: act_7786837829063213_request_2418,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
        default: false,
    }),
    __metadata("design:type", Boolean)
], FileSelector.prototype, "multiple", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('multiple'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FileSelector.prototype, "onMultiple", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], FileSelector.prototype, "url", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('url'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FileSelector.prototype, "onUrl", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], FileSelector.prototype, "payload", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('payload'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FileSelector.prototype, "onPayload", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], FileSelector.prototype, "accept", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('accept'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FileSelector.prototype, "onAccept", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], FileSelector.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FileSelector.prototype, "onSize", null);
FileSelector = __decorate([
    (0, vue_property_decorator_1.Component)()
], FileSelector);
exports.default = FileSelector;
vue_property_decorator_1.Vue.component("FileSelector", FileSelector);
